import React, { useState } from 'react';
import { SiteSection, SiteSectionHeader } from '../../components/site';
import type { SolutionFaqsConfig } from './types';

export const SolutionFaqs: React.FC<{ faqs: SolutionFaqsConfig }> = ({ faqs }) => {
  const items = faqs.items ?? [];
  const [openIndex, setOpenIndex] = useState<number>(0);

  if (!items.length) return null;

  return (
    <SiteSection id="faqs" className="solution-faqs">
      <SiteSectionHeader
        eyebrow={faqs.eyebrow ?? 'FAQs'}
        title={faqs.title}
        align="center"
      />

      <div className="solution-faqs__wrap">
        {items.map((item, i) => {
          const isOpen = openIndex === i;
          return (
            <div key={item.question} className={`solution-faqs__item${isOpen ? ' is-open' : ''}`}>
              <button
                type="button"
                className="solution-faqs__q"
                aria-expanded={isOpen}
                onClick={() => setOpenIndex((prev) => (prev === i ? -1 : i))}
              >
                <span className="solution-faqs__q-num">{i + 1}.</span>
                <span className="solution-faqs__q-text">{item.question}</span>
                <span className="solution-faqs__chev" aria-hidden />
              </button>
              <div className="solution-faqs__a" role="region">
                <p>{item.answer}</p>
              </div>
            </div>
          );
        })}
      </div>
    </SiteSection>
  );
};

